require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./twittersphere-dev.json") })
        }
      }, "path---twittersphere-dev");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---twittersphere-dev!./.cache/json/twittersphere-dev.json
// module id = 318
// module chunks = 231608221292675